var $ = require('jquery');
var TorsoBehavior = require('backbone-torso/modules/Behavior');

/**
 * This behavior applies select2 to all 'select' dom elements in the view.
 *
 * @class Select2Behavior
 * @constructor
 */
module.exports = TorsoBehavior.extend({

  /**
   * Options passed to the select2 widget.
   *
   * @property __select2Options
   * @type Object
   * @private
   * @default {}
   */
  __select2Options: null,

  /**
   * jQuery selector to use to select the select elements to apply Select2 to.
   * Defaults to all elements in the view with the 'brec-select2' class.
   *
   * @property __select2ElementSelector
   * @type String
   * @private
   * @default '.brec-select2'
   */
  __select2ElementSelector: '.brec-select2',

  /**
   * @method initialize
   * @param attributes {Object}
   * @param options {Object}
   *   @param [options.select2Options={}] {Object} any options to pass to the select2 widget.
   *   @param [options.select2ElementSelector='select'] {String} the jQuery selector to use to select the select elements to apply Select2 to.
   */
  initialize: function(attributes, options) {
    options = options || {};
    this.__select2Options = options.select2Options || {};
    this.__select2ElementSelector = options.select2ElementSelector || this.__select2ElementSelector;
  },

  mixin: {
    /**
     * Update the select2 container (parent).  dropdownParent in select2 options.
     * @method mixin.setSelect2DropdownParent
     * @param newDropdownParent {jQuery|Element} jQuery result or DOM element to set as the container for the select2 stuff.
     */
    setSelect2DropdownParent: function(newDropdownParent) {
      var $newDropdownParent = $(newDropdownParent);
      var newDropdownParentElement = $newDropdownParent && $newDropdownParent.length > 0 && $newDropdownParent.get(0);
      var $currentDropdownParent = $(this.__select2Options.dropdownParent);
      var currentDropdownParentElement = $currentDropdownParent && $currentDropdownParent.length > 0 && $currentDropdownParent.get(0);
      // Check that the elements are equals because jQuery selectors are unreliable as instance equals.
      // Only cause a render if the parent element changes.
      if (newDropdownParentElement !== currentDropdownParentElement) {
        this.__select2Options.dropdownParent = $newDropdownParent;
        this.__recreateSelect2Widget();
      }
    },

    /**
     * Sets the select2 options to use (must be called before setSelect2DropdownParent for the dropdown parent to work.
     * @method mixin.setSelect2Options
     * @param select2Options
     */
    setSelect2Options: function(select2Options) {
      this.__select2Options = select2Options;
      this.__recreateSelect2Widget();
    }
  },

  /**
   * Destroy the existing widget, then create a new widget.
   * @method __recreateSelect2Widget
   * @private
   */
  __recreateSelect2Widget: function() {
    this.__destroyExistingSelect2Widget();
    this.__createSelect2Widget();
  },

  /**
   * Remove the widget from the dom and destroy anything else it has setup.
   * @method __createSelect2Widget
   * @private
   */
  __createSelect2Widget: function() {
    this._$selects = this.view.$el.find(this.__select2ElementSelector);
    this._$selects.select2(this.__select2Options);
  },

  /**
   * Remove the widget from the dom and destroy anything else it has setup.
   * @method __destroyExistingSelect2Widget
   * @private
   */
  __destroyExistingSelect2Widget: function() {
    if (this._$selects && this._$selects.length > 0 && $.contains(document, this._$selects)) {
      this._$selects.select2('destroy');
      delete this._$selects;
    }
  },

  /**
   * @method prerender
   * @override
   */
  prerender: function() {
    this.__destroyExistingSelect2Widget();
  },

  /**
   * @method postrender
   * @override
   */
  postrender: function() {
    this.__createSelect2Widget();
  },

  /**
   * @method _dispose
   * @private
   * @override
   */
  _dispose: function() {
    this.__destroyExistingSelect2Widget();
  }
});
